webpackJsonp([48],{

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(741);

/***/ }),

/***/ 741:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db3e8226_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_vue_markdown_loader_lib_markdown_compiler_js_raw_home_sidemenus_md__ = __webpack_require__(742);
var normalizeComponent = __webpack_require__(20)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db3e8226_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_vue_markdown_loader_lib_markdown_compiler_js_raw_home_sidemenus_md__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 742:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('h3',[_vm._v("投稿")]),_vm._v(" "),_c('p',[_vm._v("投稿（お知らせや新着情報）の新規作成・編集・削除ができます。投稿の編集はコンポーネント単位での編集になります。コンポーネントの追加後は、コンポーネント内のコンテンツを編集・保存するだけで投稿が出来上がります。")]),_vm._v(" "),_c('h3',[_vm._v("固定ページ")]),_vm._v(" "),_c('p',[_vm._v("固定ページの新規作成・編集・削除ができます。固定ページの編集はコンポーネント単位での編集になります。\n新規作成時にはテンプレートを選択することで、下層ページに合わせて最適なコンポーネントがあらかじめ選択された状態で固定ページを追加することができます。追加後はコンポーネント内のコンテンツを編集・保存するだけで固定ページが出来上がります。")]),_vm._v(" "),_c('h3',[_vm._v("アップロード画像")]),_vm._v(" "),_c('p',[_vm._v("画像の新規アップロード・編集・削除ができます。SEO対策のため、アップロード後に代替テキストを入力して更新してください。")]),_vm._v(" "),_c('h3',[_vm._v("サイトテーマ")]),_vm._v(" "),_c('p',[_vm._v("サイトデザインを左右するナビゲーション、フッター、サイドバー（スマホでのナビゲーションメニュー）コンポーネントを追加・編集・削除することができます。")]),_vm._v(" "),_c('h3',[_vm._v("サイト設定")]),_vm._v(" "),_c('p',[_vm._v("サイトの所有者やSNSアカウント、構造化データ等のSEO（検索エンジン最適化）対策のための情報を設定します。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/48.63a4c7770cf9d80bf281.js